import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";

// Initialize Sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN, // Move DSN to environment variable
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing config
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  tracePropagationTargets: [
    "localhost",
    "getborrowed.com",
    /^https:\/\/getborrowed\.com\/api/
  ],
  // Session Replay config
  replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  // Environment
  environment: process.env.NODE_ENV
});

// Create error boundary component
const SentryErrorBoundary = Sentry.ErrorBoundary;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<p>An error has occurred</p>}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SentryErrorBoundary>
  </React.StrictMode>
);

reportWebVitals(metric => {
  // Send metrics to Sentry
  Sentry.setTag("web-vital", metric.name);
  Sentry.setMeasurement(metric.name, metric.value, metric.rating);
});